module.exports = __webpack_public_path__ + "static/media/luis.e55172a4.PNG";